import { Download } from "@mui/icons-material"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from "@mui/material"
import moment from "moment"
import { useContext, useRef, useState } from "react"
import { renderToStaticMarkup, renderToString } from "react-dom/server"
import $data from "../../services/$data"
import { variables } from "../../styles/abstract/variables"
import { DataContext } from "../DataContext";

const tags = [
  'No-till',
  'Reduced or minimum tillage',
  'Cover crops',
  'Crop rotation',
  'Mulching',
  'Agroforestry and silvopasture',
  'Hedgerows, flower strips, shrubs',
  'Composting',
  'Biochar',
  'Holistically managed grazing',
  'Animal integration into crop production',
  'Perennial cropping',
];

const tableStyle = {
  pageBreakInside: 'avoid',
  width: '100%',
  borderSpacing: 0, borderCollapse: "collapse",
  margin: '10px auto 40px auto'
}

const thStyle = {
  padding: '10px',
  textAlign: 'left',
  fontSize: '13px',
  border: '1px solid #555',
  color: variables.primary
}

const tdStyle = {
  padding: '7px',
  fontSize: '11px',
  border: '1px solid #555',
  textTransform: 'uppercase'
}

function DeclaredTemplate(props) {
  const { projectData } = useContext(DataContext);
  const downloadRef = useRef(null);
  const photos = projectData[props.projectId].photos;
  const [loading, setLoading] = useState(false);

  const downloadPDF = () => {
    setLoading(true);
    const htmlString = renderToStaticMarkup(renderContent());
    $data.downloadPDF(htmlString)
      .then((data) => {
        downloadRef.current.href = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
        downloadRef.current.download = 'declared_activities.pdf';
        downloadRef.current.click();
        window.URL.revokeObjectURL(downloadRef.current.href);
        setLoading(false);

      })
      .catch(err => {
        setLoading(false);
        console.log(err);
      })
  }

  const renderContent = () => {
    return (
      <div style={{ fontFamily: 'sans-serif', margin: '10px 20px' }}>
        <div style={{ textAlign: 'center' }}>
          <img width="400" src="data:image/svg+xml;base64,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" />
        </div>
        <h2 style={{ textAlign: 'center', color: variables.primary }}>Report on activities declared by farmer</h2>
        <hr style={{ borderColor: variables.primary }} />
        {renderTables()}
      </div>
    )
  }

  const renderTillageItem = (item) => {
    if (item === '-' || !item) return '-';

    if (item === '-') return ' - ';

    try {
      if (!item) return ' - ';

      if (item === '-') return '-';

      if (item === 'NA' || item === 'N/A') return ' - ';



      let resp = Object.keys(item).map((date, key) => {
        return <div style={{ marginBottom: '5px' }}>{date}: {item[date]}</div>
      })

      return resp;

    } catch (error) {
      return '-';
    }
  }

  const renderRegAgri = (item) => {
    if (!item) return ' - ';;

    if (item === '-') return ' - ';

    return item.split(';').map((practice, i) => {
      return <div key={i} style={{ paddingBottom: '3px' }}>{practice}</div>
    })
  }

  const renderPhotos = (tags, photos = [], year = '2023') => {
    let filtered = photos.filter(p => tags.indexOf(p.tag) > -1 && moment(p.date_time).format('YYYY') === year);
    if (filtered.length === 0) return null;

    return <div style={{ padding: '5px 0' }}>{filtered.map((photo, key) => <a style={{ padding: '5px', display: 'inline-block' }} href={photo.image} target="_blank">Photo{key + 1}</a>)} </div>
  }

  const renderCoverCropItem = (item) => {
    if (item === '-') return ' - ';

    try {
      return item.map((cc, i) => {
        return <div key={i} style={{ paddingBottom: '3px' }}>{cc}</div>
      })
    } catch (e) {
      console.log(e)
      return ' - '
    }

    return item ? 'YES' : 'NO';
  }

  const renderFertilizers = (item) => {
    if (!item) return ' - ';

    if (item === '-') return ' - ';


    try {
      return item.map((f, i) => {
        return <div key={i} style={{ paddingBottom: '3px' }}>{f}</div>
      })
    } catch (e) {
      return ' - ';
    }

  }
  const renderPesticides = (item) => {
    if (!item) return ' - ';

    if (item === '-') return ' - ';

    try {
      return item.map((p, i) => {
        return <div key={i} style={{ paddingBottom: '3px' }}>{p}</div>
      })
    } catch (e) {
      return ' - ';
    }
  }

  const renderIrrigation = (item) => {
    if (!item) return ' - ';;

    if (item === '-') return ' - ';

    return item;
  }

  const renderFuel = (item) => {
    if (!item) return ' - ';;

    if (item === '-') return ' - ';

    return item;
  }

  const renderTables = () => {
    if (!props.data) return (
      <p>Error occured while trying to display the report content. Please contact our technical support.</p>
    )

    if (props.data.length === 0) return (
      <p>There are no parcels created. Please create/import parcels before trying to generate a report.</p>
    )

    return props.data.map((obj, key) => {
      let vals = Object.values(obj);
      let parcelID = Object.keys(obj)[0];
      console.log(vals)
      let filteredPhotos = photos.filter(photo => photo.parcel === parseInt(parcelID));

      let photoGroups = {};

      filteredPhotos.map(p => {
        if (photoGroups.hasOwnProperty(moment(p.date_time).format('YYYY'))) {
          photoGroups[moment(p.date_time).format('YYYY')].push(p);
        } else {
          photoGroups[moment(p.date_time).format('YYYY')] = [p]

        }
      })

      console.log(photoGroups);

      return (
        <>
          <p style={{ color: variables.primary }}><strong>Parcel: {vals[0]} ({vals[1]})</strong></p>
          <table style={tableStyle} key={key}>
            <thead>
              <tr>
                {/* <th style={thStyle}>Parcel</th> */}
                <th style={thStyle}>Year</th>
                <th style={thStyle}>Regenerative practices</th>
                <th style={thStyle}>Main crop</th>
                <th style={thStyle}>Cover crop</th>
                <th style={thStyle}>Tillage</th>
                <th style={thStyle}>Soil analysis</th>
                <th style={thStyle}>Irrigation</th>
                <th style={thStyle}>Total fuel consumption</th>
                <th style={thStyle}>Fertilizers</th>
                <th style={thStyle}>Pesticides/fungicides</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(vals[2]).map((year, k) => {

                let item = vals[2][year];


                if (photoGroups[year]) {
                  // return null;

                  return (<><tr key={k}>

                    {vals[2]['No data'] && <td style={{ ...tdStyle, textAlign: 'center' }} colSpan={6}>{item}</td>}
                    {!vals[2]['No data'] && <><td rowSpan={2} style={{ ...tdStyle, fontWeight: 'bold' }}>{year}</td>
                      <td style={{ ...tdStyle, fontWeight: 'bold', color: variables.primary, whiteSpace: 'nowrap', }}>{renderRegAgri(item['Regenerative practices'])}</td>
                      <td style={{ ...tdStyle, whiteSpace: 'nowrap', }}>{item['Main crop'] || ' - '}</td>
                      <td style={{ ...tdStyle, }}>{renderCoverCropItem(item['Cover crop'])}{renderPhotos(['Cover crops'], filteredPhotos, year)}</td>
                      <td style={{ ...tdStyle, }}>{renderTillageItem(item['Tillage'])}{renderPhotos(['No-till', 'Reduced or minimum tillage'], filteredPhotos, year)}</td>
                      <td style={{ ...tdStyle, textTransform: 'unset' }}>{item['Soil analysis']}</td>
                      <td style={{ ...tdStyle, textTransform: 'unset' }}>{renderIrrigation(item['Irrigation'])}</td>
                      <td style={{ ...tdStyle, textTransform: 'unset' }}>{renderFuel(item['Fuel consumption'])}</td>
                      <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>{renderFertilizers(item['Use of fertilizers'])}</td>
                      <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>{renderPesticides(item['Use of pesticides/fungicides'])}</td>
                    </>
                    }

                  </tr>
                    <tr>
                      <td colSpan={9} style={{ ...tdStyle, whiteSpace: 'nowrap', }}>
                        {photoGroups[year].map((photo, ind) => <a key={ind} href={photo.image} target="_blank" style={{ display: 'inline-block', borderRadius: '25px', background: 'darkorange', color: '#fff', fontWeight: 'bold', padding: '10px', margin: '3px', border: '1px solid darkorange' }}>
                          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

                            <svg fill="#fff" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 487 487" xmlXpace="preserve">
                              <g>
                                <g>
                                  <path d="M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z
			 M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9
			v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z
			 M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z
			 M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"/>
                                </g>
                              </g>
                            </svg>
                            <div style={{marginLeft: '10px'}}>
                              <div style={{marginBottom: '2px'}}>{photo.date_time}</div>
                              <div>{photo.tag?.split(';').map((t, j) => `#${t}`).join(' ')}</div>
                            </div>
                          </div>
                        </a>)}
                      </td>
                    </tr>
                  </>)
                }

                return <tr key={k}>

                  {vals[2]['No data'] && <td style={{ ...tdStyle, textAlign: 'center' }} colSpan={6}>{item}</td>}
                  {!vals[2]['No data'] && <><td style={{ ...tdStyle, fontWeight: 'bold' }}>{year}</td>
                    <td style={{ ...tdStyle, fontWeight: 'bold', color: variables.primary, whiteSpace: 'nowrap', }}>{renderRegAgri(item['Regenerative practices'])}</td>
                    <td style={{ ...tdStyle, whiteSpace: 'nowrap', }}>{item['Main crop'] || ' - '}</td>
                    <td style={{ ...tdStyle, }}>{renderCoverCropItem(item['Cover crop'])}{renderPhotos(['Cover crops'], filteredPhotos, year)}</td>
                    <td style={{ ...tdStyle, }}>{renderTillageItem(item['Tillage'])}{renderPhotos(['No-till', 'Reduced or minimum tillage'], filteredPhotos, year)}</td>
                    <td style={{ ...tdStyle, textTransform: 'unset' }}>{item['Soil analysis']}</td>
                    <td style={{ ...tdStyle, textTransform: 'unset' }}>{renderIrrigation(item['Irrigation'])}</td>
                    <td style={{ ...tdStyle, textTransform: 'unset' }}>{renderFuel(item['Fuel consumption'])}</td>
                    <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>{renderFertilizers(item['Use of fertilizers'])}</td>
                    <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>{renderPesticides(item['Use of pesticides/fungicides'])}</td>
                  </>
                  }

                </tr>
              })}
            </tbody>
          </table>
        </>
      )
    })
  }

  return <Dialog PaperProps={{ className: 'co-background-white' }} fullWidth maxWidth="xl" open={props.open} onClose={props.onClose}>
    <DialogTitle color="primary">Declared activities report</DialogTitle>
    <DialogContent>
      {loading && <LinearProgress color="primary" />}

      {renderContent()}
      <a ref={downloadRef}></a>

    </DialogContent>
    <DialogActions>
      <Button variant="contained" disabled={loading} onClick={downloadPDF} style={{ lineHeight: 'unset' }} color="primary" startIcon={<Download />}>Download PDF</Button>
      <Button variant="contained" disabled={loading} onClick={props.onClose} style={{ lineHeight: 'unset' }} color="error">Close</Button>
    </DialogActions>

  </Dialog>
}

export default DeclaredTemplate;